import axios from 'axios';
import { ResistanceTypeDTO } from '../dto/ResistanceTypeDTO';
import { routePrefix } from '../app/App';

export async function getResistanceTypes(query: string): Promise<ResistanceTypeDTO[]> {
  const url = `${routePrefix()}resistance-types${query}`;
  const { data } = await axios.get<ResistanceTypeDTO[]>(url);
  return data;
}
